/**
 * Tính chất hoạt động
 */
export default {
  AutonomyFunding: 5,
  NotAutonomyFunding: 10,
};
